module.exports = __webpack_public_path__ + "static/acrylic03-707e863c0e72fecb7ad7e69981f49e40.jpg";